"use client";

import { initSentry } from "@pex/observability/client";
import { useEffect } from "react";

export function SentryInit({ dsn }: { dsn: string }) {
  useEffect(() => {
    initSentry(dsn);
  }, [dsn]);

  return null;
}
